import _wellKnownSymbolDefine from "../internals/well-known-symbol-define";
var defineWellKnownSymbol = _wellKnownSymbolDefine;

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol("match");
export default {};